import { Injectable } from '@angular/core';

/**
 * Service to get the host location to be mocked in tests, normally returns window.location.host
 */
@Injectable({
  providedIn: 'root',
})
export class HostLocationService {
  getHost(): string {
    return window.location.host;
  }
}
